import { combineReducers } from 'redux';
import merchant from './merchant/merchant.slice';
import sidebar from './sidebar/sidebar.slice';
import theme from './theme/theme.slice';
import program from './program/program.slice';

export default combineReducers({
  [sidebar.name]: sidebar.reducer,
  [theme.name]: theme.reducer,
  [merchant.name]: merchant.reducer,
  [program.name]: program.reducer,
});
